import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_BLOPED_FECHAS,
  ALL_BLOPED_FECHAS,
  LOADING_ALL_BLOPED_FECHAS,
} from './BlopedFechasReducer';
import {
  allBlopedFechasService,
  deleteBlopedFechasService,
  oneBlopedFechasService,
  saveBlopedFechasService,
} from './BlopedFechasService';

export const allBlopedFechasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_BLOPED_FECHAS, payload: true });
    const res = await allBlopedFechasService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_BLOPED_FECHAS, payload: res.data });
      dispatch({ type: LOADING_ALL_BLOPED_FECHAS, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_BLOPED_FECHAS, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_BLOPED_FECHAS, payload: false });
    tryCatchHelper(e);
  }
};

export const saveBlopedFechasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveBlopedFechasService(id, data);
    notify(res.data.message);
    await allBlopedFechasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoBlopedFechasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_BLOPED_FECHAS, payload: data });
};

export const oneBlopedFechasAction = async (dispatch, id) => {
  try {
    const res = await oneBlopedFechasService(id);
    await setActivoBlopedFechasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteBlopedFechasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteBlopedFechasService(id);
    await setActivoBlopedFechasAction(dispatch, null);
    notify(res.data.message);
    await allBlopedFechasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
